'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['button:enabled:not([readonly])', 'select:enabled:not([readonly])', 'textarea:enabled:not([readonly])', 'input:enabled:not([readonly])', 'a[href]', 'area[href]', 'iframe', 'object', 'embed', '[tabindex]', '[contenteditable]', '[autofocus]'];


//////////////////
// WEBPACK FOOTER
// ./~/focus-lock/dist/cjs/utils/tabbables.js
// module id = 1768
// module chunks = 0